import { Component } from '@angular/core';
import { NavController, NavParams, AlertController, LoadingController } from 'ionic-angular';

import { ConsumerOfferManagerHandler } from '../../providers/consumer-offer-handler';
import { ConsumerBusinessDetailPage } from '../../pages/consumer-business-detail/consumer-business-detail';

import { Globals } from '../../providers/globals';
import { Utils } from '../../helpers/utils';

/**
 * Generated class for the ConsumerOfferDetailPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-consumer-offer-detail',
  templateUrl: 'consumer-offer-detail.html',
})
export class ConsumerOfferDetailPage {
	filePath: any;	
	loader: any;
	qrCodeUrl: any;	
	caller: any;

	refreshDone: boolean = false;
	leftView: boolean = false;
	isLoading: boolean = false;

	lastRedeemDate: any;
	needsRefresh: boolean = false;

	apiCallQty: any = 0;

	constructor(
		public navCtrl: NavController, 
		public navParams: NavParams,
		public alertCtrl: AlertController,
		public utils: Utils,
		public offerProvider: ConsumerOfferManagerHandler,
		public loadingCtrl: LoadingController,
		public globals: Globals,
	) {
		let offer = this.offerProvider.selectedOffer;

		this.filePath = this.globals.fileUrl;		

		if(!this.offerProvider.selectedOffer.RedeemedDate){
			this.qrCodeUrl = this.globals.dataUrl + "qrcode/" + offer.InvoiceDetailId + '~' + offer.UserId;		   
		}				
	}

	ionViewDidEnter() {
		this.leftView = false;

		if(!this.offerProvider.selectedOffer.RedeemedDate){
			this.reLoad();
		}		
	}	

	ionViewDidLeave(){
		this.leftView = true;
	}		

	reLoad(){
		if(this.apiCallQty==15){
			this.leftView = true;
			this.navCtrl.pop();
		}else{
			if(!this.refreshDone){
				this.isLoading = true;			
			}

			this.refreshDone = false;

			this.offerProvider.getOffer({
				id: this.offerProvider.selectedOffer.InvoiceDetailId, 
				cb: (offer)=>{
					if(!this.refreshDone){
						this.isLoading = false;			
					}	

					this.redeemOffer(offer);

					this.lastRedeemDate = offer.RedeemedDate;

			  		if(this.leftView==false){
				   		setTimeout(()=>{
				   			if(this.leftView==false && this.needsRefresh){
				   				this.refreshDone = true;
				   				this.apiCallQty++;
				   				this.reLoad();
				   			}			   			
				   		}, 2000);	 				  			
			  		}  		  					
				}
			})
		}
	}

	redeemOffer(offer){
		this.offerProvider.selectedOffer = offer;

		if(offer.RedeemedDate!=this.lastRedeemDate){
			let alert = this.alertCtrl.create({
				title: 'Offer redeemed',
				subTitle: 'Enjoy!',
				buttons: ['Ok']
			});

			alert.present();				

			// this.offerProvider.updateOffer(offer);
			
			this.needsRefresh = false;
		}else{
			this.needsRefresh = true;
		}
	}

	gotoBusiness(id){
		this.navCtrl.push(ConsumerBusinessDetailPage, {
			requiresReload: true,
			businessId: id
		});			
	}	

}



// WEBPACK FOOTER //
// ./src/pages/consumer-offer-detail/consumer-offer-detail.ts